import React from 'react';
import { useSpring, useSprings, animated, config } from 'react-spring';
import { Stylable } from '@content/types/general';
import { WaypointDependent } from './AnimationTriggerWaypoint';

interface Props extends Stylable, WaypointDependent {}

const strokeDasharrays = [400, 220, 400];
const initialDelay = 1000;
const stepsDelay = 500;

export default (props: Props) => {
  // lines animation
  const [animLines, animLinesSet] = useSprings(strokeDasharrays.length, i => ({
    from: { strokeDashoffset: 1 * strokeDasharrays[i] },
    config: config.slow,
  }));
  animLinesSet(i => ({
    strokeDashoffset: props.sectionVisible ? 0 : 1 * strokeDasharrays[i],
    delay: initialDelay,
  }));

  // dots animation
  const [animDots, animDotsSet] = useSprings(2, i => ({
    from: { opacity: 0 /*, transform: 'scale(0)'*/ },
    config: config.default,
  }));
  animDotsSet(i => ({
    opacity: props.sectionVisible ? 1 : 0,
    // transform: props.sectionVisible ? 'scale(1)' : 'scale(0)',
    delay: initialDelay + i * stepsDelay,
  }));

  // icon animation
  const [animIcons, animIconsSet] = useSprings(3, i => ({
    from: { opacity: 0, transform: 'translate(-2%, 0%)' },
    config: config.subtle,
  }));
  animIconsSet(i => ({
    opacity: props.sectionVisible ? 1 : 0,
    transform: props.sectionVisible ? 'translate(0, 0)' : 'translate(-2%, 0%)',
    delay: initialDelay + stepsDelay,
  }));

  return (
    <div className={props.className}>
      <svg xmlns="http://www.w3.org/2000/svg" width="306px" height="470px" viewBox="0 0 306 470">
        <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Franczyzy" transform="translate(-749.000000, -1063.000000)">
            <g id="2.-Jak-to-działa" transform="translate(266.000000, 810.000000)">
              <g id="Infografika" transform="translate(483.000000, 199.000000)">
                <g id="lines" transform="translate(0.000000, 53.500000)">
                  <animated.path
                    strokeDasharray={strokeDasharrays[0]}
                    strokeDashoffset={animLines[0].strokeDashoffset}
                    d="M10.5 218h136c12.703 0 23-10.297 23-23V60c0-12.703 10.297-23 23-23h30"
                    id="Line-6"
                    stroke="#009944"
                    strokeLinecap="square"
                    transform="rotateZ(180deg)"
                    // transform="translate(115.081701, 127.500000) scale(-1, 1) translate(-115.081701, -127.500000) "
                  ></animated.path>
                  <animated.path
                    strokeDasharray={strokeDasharrays[2]}
                    strokeDashoffset={animLines[2].strokeDashoffset}
                    d="M10.5,257.5 L150.096996,257.5 C161.142691,257.5 170.096996,266.454305 170.096996,277.5 L170.096996,365.980469 L170.096996,365.980469 L170.096996,418.5 C170.096996,429.545695 179.051301,438.5 190.096996,438.5 L219.663402,438.5 L219.663402,438.5"
                    id="Line-6-Copy-2"
                    stroke="#009944"
                    strokeLinecap="square"
                  ></animated.path>
                  <animated.line
                    strokeDasharray={strokeDasharrays[1]}
                    strokeDashoffset={animLines[1].strokeDashoffset}
                    x2="4.5"
                    y1="238"
                    x1="222.5"
                    y2="238"
                    id="Line-8"
                    stroke="#009944"
                    strokeLinecap="square"
                    transform="translate(113.500000, 238.000000) scale(-1, 1) translate(-113.500000, -238.000000) "
                  ></animated.line>

                  {/* dots */}
                  <animated.circle
                    style={animDots[0]}
                    id="Oval"
                    fill="#009944"
                    cx="4.5"
                    cy="238.5"
                    r="4.5"
                  ></animated.circle>
                  <animated.circle
                    style={animDots[1]}
                    id="Oval-Copy-9"
                    fill="#009944"
                    cx="222.5"
                    cy="238.5"
                    r="4.5"
                  ></animated.circle>
                  <animated.circle
                    style={animDots[1]}
                    id="Oval-Copy-11"
                    fill="#009944"
                    cx="222.5"
                    cy="438.5"
                    r="4.5"
                  ></animated.circle>
                  <animated.circle
                    style={animDots[1]}
                    id="Oval-Copy-10"
                    fill="#009944"
                    cx="222.5"
                    cy="36.5"
                    r="4.5"
                  ></animated.circle>
                  <animated.circle
                    style={animDots[0]}
                    id="Oval-Copy-7"
                    fill="#009944"
                    cx="10.5"
                    cy="217.5"
                    r="4.5"
                  ></animated.circle>
                  <animated.circle
                    style={animDots[0]}
                    id="Oval-Copy-8"
                    fill="#009944"
                    cx="10.5"
                    cy="257.5"
                    r="4.5"
                  ></animated.circle>

                  {/* icon 1 */}
                  <animated.g style={animIcons[0]} id="sklep3">
                    <g transform="translate(254.000000, 400.500000)">
                      <path
                        d="M36.1651667,34.1666667 L15.8351667,34.1666667 C14.4318333,34.1666667 13.1801667,33.29 12.7018333,31.9733333 L8.50016667,15.8333333 L43.5001667,15.8333333 L39.2968333,31.9733333 C38.8185,33.29 37.5668333,34.1666667 36.1651667,34.1666667 Z"
                        id="Stroke-1"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M31.8333333,0.833333333 L34.95,0.833333333 C36.3333333,0.833333333 37.55,1.66666667 38.05,2.95 L41.8333333,10.8333333 L10.1666667,10.8333333 L13.95,2.95 C14.45,1.66666667 15.6666667,0.833333333 17.05,0.833333333 L20.1666667,0.833333333"
                        id="Stroke-3"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M43.5,15.8333333 L8.5,15.8333333 C7.58,15.8333333 6.83333333,15.0883333 6.83333333,14.1666667 L6.83333333,12.5 C6.83333333,11.5783333 7.58,10.8333333 8.5,10.8333333 L43.5,10.8333333 C44.42,10.8333333 45.1666667,11.5783333 45.1666667,12.5 L45.1666667,14.1666667 C45.1666667,15.0883333 44.42,15.8333333 43.5,15.8333333 Z"
                        id="Stroke-7"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <line
                        x1="18.5"
                        y1="20.8333333"
                        x2="18.5"
                        y2="29.1666667"
                        id="Stroke-9"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <line
                        x1="26.8333333"
                        y1="20.8333333"
                        x2="26.8333333"
                        y2="29.1666667"
                        id="Stroke-11"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <line
                        x1="35.1666667"
                        y1="20.8333333"
                        x2="35.1666667"
                        y2="29.1666667"
                        id="Stroke-13"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <path
                        d="M1.456,63.904 L0.8,64.752 L0.882497993,64.8374504 C1.19734431,65.1470617 2.40533333,66.192 4.368,66.192 C6.48,66.192 7.776,64.832 7.776,63.152 C7.776,59.456 2.16,60.224 2.16,57.552 C2.16,56.56 3.088,55.616 4.528,55.616 C6,55.616 6.992,56.576 6.992,56.576 L7.536,55.648 L7.44874074,55.5674074 C7.15911111,55.3155556 6.15466667,54.56 4.528,54.56 C2.448,54.56 1.024,55.968 1.024,57.584 C1.024,61.072 6.64,60.352 6.64,63.184 C6.64,64.4 5.632,65.136 4.4,65.136 C2.624,65.136 1.456,63.904 1.456,63.904 Z M9.92,66 L11.008,66 L11.008,61.968 L12.304,61.968 L14.992,66 L16.288,66 L13.216,61.488 L13.216,61.456 L16.016,57.952 L14.704,57.952 L12.288,61.024 L11.008,61.024 L11.008,54.752 L9.92,54.752 L9.92,66 Z M17.872,64.096 C17.872,65.856 19.056,66.064 19.728,66.064 C19.936,66.064 20.128,66.032 20.128,66.032 L20.128,65.056 L20.046,65.064 C19.996,65.068 19.928,65.072 19.856,65.072 C19.44,65.072 18.96,64.912 18.96,63.856 L18.96,54.752 L17.872,54.752 L17.872,64.096 Z M21.344,61.984 C21.344,64.464 23.152,66.192 25.552,66.192 C27.36,66.192 28.528,65.072 28.528,65.072 L28.032,64.24 L27.9290858,64.3327416 C27.642195,64.5763991 26.775619,65.216 25.584,65.216 C23.92,65.216 22.512,64.096 22.464,62.032 L28.64,62.032 L28.667,61.6405 C28.67,61.579 28.672,61.52 28.672,61.472 C28.672,59.472 27.536,57.76 25.312,57.76 C23.136,57.76 21.344,59.344 21.344,61.984 Z M22.512,61.136 C22.768,59.52 23.936,58.672 25.28,58.672 C26.48,58.672 27.504,59.456 27.568,61.136 L22.512,61.136 Z M30.752,69.2 L31.84,69.2 L31.84,65.36 C31.84,64.944 31.808,64.656 31.808,64.656 L31.84,64.656 L31.8962299,64.7613819 C32.0968192,65.1081984 32.85376,66.192 34.48,66.192 C36.56,66.192 38.08,64.528 38.08,61.984 C38.08,59.488 36.736,57.76 34.576,57.76 C32.448,57.76 31.792,59.36 31.792,59.36 L31.76,59.36 L31.7786557,59.14107 C31.7839232,59.0600823 31.7887956,58.9607243 31.7909026,58.850107 L31.792,57.952 L30.752,57.952 L30.752,69.2 Z M31.808,62 C31.808,59.712 33.072,58.752 34.416,58.752 C35.92,58.752 36.96,60.016 36.96,61.984 C36.96,64.032 35.792,65.232 34.368,65.232 C32.704,65.232 31.808,63.616 31.808,62 Z M43.888,64.656 L44.56,63.808 L44.6533333,63.9063704 C44.96,64.2137778 46,65.136 47.44,65.136 C48.784,65.136 50.016,64.144 50.016,62.704 C50.016,61.12 48.656,60.304 47.184,60.304 L46.416,60.304 L46.144,59.648 L48.96,56.352 L49.138304,56.151936 C49.36768,55.90208 49.552,55.728 49.552,55.728 L49.552,55.696 L49.4273659,55.7104252 C49.2833058,55.724562 49.0167273,55.744 48.64,55.744 L44.416,55.744 L44.416,54.752 L50.992,54.752 L50.992,55.488 L47.632,59.36 C49.056,59.44 51.152,60.24 51.152,62.672 C51.152,64.592 49.584,66.192 47.456,66.192 C45.248,66.192 43.888,64.656 43.888,64.656 Z"
                        id="Sklep3"
                        fill="#6A6A6A"
                        fillRule="nonzero"
                      ></path>
                    </g>
                  </animated.g>
                  <animated.g style={animIcons[0]} id="sklep2">
                    <g transform="translate(254.000000, 200.500000)">
                      <path
                        d="M36.1651667,34.1666667 L15.8351667,34.1666667 C14.4318333,34.1666667 13.1801667,33.29 12.7018333,31.9733333 L8.50016667,15.8333333 L43.5001667,15.8333333 L39.2968333,31.9733333 C38.8185,33.29 37.5668333,34.1666667 36.1651667,34.1666667 Z"
                        id="Stroke-1"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M31.8333333,0.833333333 L34.95,0.833333333 C36.3333333,0.833333333 37.55,1.66666667 38.05,2.95 L41.8333333,10.8333333 L10.1666667,10.8333333 L13.95,2.95 C14.45,1.66666667 15.6666667,0.833333333 17.05,0.833333333 L20.1666667,0.833333333"
                        id="Stroke-3"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M43.5,15.8333333 L8.5,15.8333333 C7.58,15.8333333 6.83333333,15.0883333 6.83333333,14.1666667 L6.83333333,12.5 C6.83333333,11.5783333 7.58,10.8333333 8.5,10.8333333 L43.5,10.8333333 C44.42,10.8333333 45.1666667,11.5783333 45.1666667,12.5 L45.1666667,14.1666667 C45.1666667,15.0883333 44.42,15.8333333 43.5,15.8333333 Z"
                        id="Stroke-7"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <line
                        x1="18.5"
                        y1="20.8333333"
                        x2="18.5"
                        y2="29.1666667"
                        id="Stroke-9"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <line
                        x1="26.8333333"
                        y1="20.8333333"
                        x2="26.8333333"
                        y2="29.1666667"
                        id="Stroke-11"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <line
                        x1="35.1666667"
                        y1="20.8333333"
                        x2="35.1666667"
                        y2="29.1666667"
                        id="Stroke-13"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <path
                        d="M1.456,63.904 L0.8,64.752 L0.882497993,64.8374504 C1.19734431,65.1470617 2.40533333,66.192 4.368,66.192 C6.48,66.192 7.776,64.832 7.776,63.152 C7.776,59.456 2.16,60.224 2.16,57.552 C2.16,56.56 3.088,55.616 4.528,55.616 C6,55.616 6.992,56.576 6.992,56.576 L7.536,55.648 L7.44874074,55.5674074 C7.15911111,55.3155556 6.15466667,54.56 4.528,54.56 C2.448,54.56 1.024,55.968 1.024,57.584 C1.024,61.072 6.64,60.352 6.64,63.184 C6.64,64.4 5.632,65.136 4.4,65.136 C2.624,65.136 1.456,63.904 1.456,63.904 Z M9.92,66 L11.008,66 L11.008,61.968 L12.304,61.968 L14.992,66 L16.288,66 L13.216,61.488 L13.216,61.456 L16.016,57.952 L14.704,57.952 L12.288,61.024 L11.008,61.024 L11.008,54.752 L9.92,54.752 L9.92,66 Z M17.872,64.096 C17.872,65.856 19.056,66.064 19.728,66.064 C19.936,66.064 20.128,66.032 20.128,66.032 L20.128,65.056 L20.046,65.064 C19.996,65.068 19.928,65.072 19.856,65.072 C19.44,65.072 18.96,64.912 18.96,63.856 L18.96,54.752 L17.872,54.752 L17.872,64.096 Z M21.344,61.984 C21.344,64.464 23.152,66.192 25.552,66.192 C27.36,66.192 28.528,65.072 28.528,65.072 L28.032,64.24 L27.9290858,64.3327416 C27.642195,64.5763991 26.775619,65.216 25.584,65.216 C23.92,65.216 22.512,64.096 22.464,62.032 L28.64,62.032 L28.667,61.6405 C28.67,61.579 28.672,61.52 28.672,61.472 C28.672,59.472 27.536,57.76 25.312,57.76 C23.136,57.76 21.344,59.344 21.344,61.984 Z M22.512,61.136 C22.768,59.52 23.936,58.672 25.28,58.672 C26.48,58.672 27.504,59.456 27.568,61.136 L22.512,61.136 Z M30.752,69.2 L31.84,69.2 L31.84,65.36 C31.84,64.944 31.808,64.656 31.808,64.656 L31.84,64.656 L31.8962299,64.7613819 C32.0968192,65.1081984 32.85376,66.192 34.48,66.192 C36.56,66.192 38.08,64.528 38.08,61.984 C38.08,59.488 36.736,57.76 34.576,57.76 C32.448,57.76 31.792,59.36 31.792,59.36 L31.76,59.36 L31.7786557,59.14107 C31.7839232,59.0600823 31.7887956,58.9607243 31.7909026,58.850107 L31.792,57.952 L30.752,57.952 L30.752,69.2 Z M31.808,62 C31.808,59.712 33.072,58.752 34.416,58.752 C35.92,58.752 36.96,60.016 36.96,61.984 C36.96,64.032 35.792,65.232 34.368,65.232 C32.704,65.232 31.808,63.616 31.808,62 Z M44.192,66 C44.144,65.744 44.128,65.504 44.128,65.28 C44.128,61.328 49.888,60.816 49.888,57.776 C49.888,56.544 48.96,55.616 47.552,55.616 C45.904,55.616 45.04,57.152 45.04,57.152 L44.208,56.592 L44.2716735,56.4794402 C44.5283265,56.052898 45.5725714,54.56 47.616,54.56 C49.76,54.56 51.04,55.952 51.04,57.712 C51.04,61.488 45.36,62.016 45.344,65.008 L51.216,65.008 L51.216,66 L44.192,66 Z"
                        id="Sklep2"
                        fill="#6A6A6A"
                        fillRule="nonzero"
                      ></path>
                    </g>
                  </animated.g>
                  <animated.g style={animIcons[0]} id="sklep1">
                    <g transform="translate(254.000000, 0.500000)">
                      <path
                        d="M36.1651667,34.1666667 L15.8351667,34.1666667 C14.4318333,34.1666667 13.1801667,33.29 12.7018333,31.9733333 L8.50016667,15.8333333 L43.5001667,15.8333333 L39.2968333,31.9733333 C38.8185,33.29 37.5668333,34.1666667 36.1651667,34.1666667 Z"
                        id="Stroke-1"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M31.8333333,0.833333333 L34.95,0.833333333 C36.3333333,0.833333333 37.55,1.66666667 38.05,2.95 L41.8333333,10.8333333 L10.1666667,10.8333333 L13.95,2.95 C14.45,1.66666667 15.6666667,0.833333333 17.05,0.833333333 L20.1666667,0.833333333"
                        id="Stroke-3"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M43.5,15.8333333 L8.5,15.8333333 C7.58,15.8333333 6.83333333,15.0883333 6.83333333,14.1666667 L6.83333333,12.5 C6.83333333,11.5783333 7.58,10.8333333 8.5,10.8333333 L43.5,10.8333333 C44.42,10.8333333 45.1666667,11.5783333 45.1666667,12.5 L45.1666667,14.1666667 C45.1666667,15.0883333 44.42,15.8333333 43.5,15.8333333 Z"
                        id="Stroke-7"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <line
                        x1="18.5"
                        y1="20.8333333"
                        x2="18.5"
                        y2="29.1666667"
                        id="Stroke-9"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <line
                        x1="26.8333333"
                        y1="20.8333333"
                        x2="26.8333333"
                        y2="29.1666667"
                        id="Stroke-11"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <line
                        x1="35.1666667"
                        y1="20.8333333"
                        x2="35.1666667"
                        y2="29.1666667"
                        id="Stroke-13"
                        stroke="#009944"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <path
                        d="M1.456,63.904 L0.8,64.752 L0.882497993,64.8374504 C1.19734431,65.1470617 2.40533333,66.192 4.368,66.192 C6.48,66.192 7.776,64.832 7.776,63.152 C7.776,59.456 2.16,60.224 2.16,57.552 C2.16,56.56 3.088,55.616 4.528,55.616 C6,55.616 6.992,56.576 6.992,56.576 L7.536,55.648 L7.44874074,55.5674074 C7.15911111,55.3155556 6.15466667,54.56 4.528,54.56 C2.448,54.56 1.024,55.968 1.024,57.584 C1.024,61.072 6.64,60.352 6.64,63.184 C6.64,64.4 5.632,65.136 4.4,65.136 C2.624,65.136 1.456,63.904 1.456,63.904 Z M9.92,66 L11.008,66 L11.008,61.968 L12.304,61.968 L14.992,66 L16.288,66 L13.216,61.488 L13.216,61.456 L16.016,57.952 L14.704,57.952 L12.288,61.024 L11.008,61.024 L11.008,54.752 L9.92,54.752 L9.92,66 Z M17.872,64.096 C17.872,65.856 19.056,66.064 19.728,66.064 C19.936,66.064 20.128,66.032 20.128,66.032 L20.128,65.056 L20.046,65.064 C19.996,65.068 19.928,65.072 19.856,65.072 C19.44,65.072 18.96,64.912 18.96,63.856 L18.96,54.752 L17.872,54.752 L17.872,64.096 Z M21.344,61.984 C21.344,64.464 23.152,66.192 25.552,66.192 C27.36,66.192 28.528,65.072 28.528,65.072 L28.032,64.24 L27.9290858,64.3327416 C27.642195,64.5763991 26.775619,65.216 25.584,65.216 C23.92,65.216 22.512,64.096 22.464,62.032 L28.64,62.032 L28.667,61.6405 C28.67,61.579 28.672,61.52 28.672,61.472 C28.672,59.472 27.536,57.76 25.312,57.76 C23.136,57.76 21.344,59.344 21.344,61.984 Z M22.512,61.136 C22.768,59.52 23.936,58.672 25.28,58.672 C26.48,58.672 27.504,59.456 27.568,61.136 L22.512,61.136 Z M30.752,69.2 L31.84,69.2 L31.84,65.36 C31.84,64.944 31.808,64.656 31.808,64.656 L31.84,64.656 L31.8962299,64.7613819 C32.0968192,65.1081984 32.85376,66.192 34.48,66.192 C36.56,66.192 38.08,64.528 38.08,61.984 C38.08,59.488 36.736,57.76 34.576,57.76 C32.448,57.76 31.792,59.36 31.792,59.36 L31.76,59.36 L31.7786557,59.14107 C31.7839232,59.0600823 31.7887956,58.9607243 31.7909026,58.850107 L31.792,57.952 L30.752,57.952 L30.752,69.2 Z M31.808,62 C31.808,59.712 33.072,58.752 34.416,58.752 C35.92,58.752 36.96,60.016 36.96,61.984 C36.96,64.032 35.792,65.232 34.368,65.232 C32.704,65.232 31.808,63.616 31.808,62 Z M44.064,66 L44.064,65.008 L46.592,65.008 L46.592,56.752 C46.592,56.432 46.608,56.128 46.608,56.128 L46.576,56.128 L46.5303704,56.2062222 C46.464,56.3093333 46.3146667,56.512 46.016,56.8 L44.816,58 L44.112,57.28 L46.656,54.752 L47.68,54.752 L47.68,65.008 L50.16,65.008 L50.16,66 L44.064,66 Z"
                        id="Sklep1"
                        fill="#6A6A6A"
                        fillRule="nonzero"
                      ></path>
                    </g>
                  </animated.g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
